export interface LinkItem {
  readonly id: string;
  readonly labelKey: string;
  readonly url: string;
}

export const LINKS: readonly LinkItem[] = [
  {
    id: "visualization-win",
    labelKey: "links.items.visualizationWin",
    url: "https://visualization.blob.core.windows.net/public-releases/LithologIQ-Visualization-win-Setup.exe",
  },
] as const;
